import { useEffect, useState } from 'react';

import { cx } from '@emotion/css';
import { Row } from 'antd';
import { isUndefined } from 'lodash';
import { useAccountSelector } from 'src/hooks';
import { IdentityVerificationInstructions, MFormSection } from 'src/lib';
import { Heading, Spacing } from 'src/styles';
import { getAccountHolderSubheader } from 'src/utils';

import { PersonalInformationForm } from './PersonalInformationForm';
import { PersonalInformationView } from './PersonalInformationView';

export const JointAccountHolderSection = () => {
  const [isEditable, setIsEditable] = useState<boolean>(false);
  const [isEditMode, setIsEditMode] = useState<boolean>(false);

  const { account } = useAccountSelector();

  const onEdit = () => {
    setIsEditMode(true);
  };

  const onCancel = () => {
    setIsEditMode(false);
  };

  const isPersonalInformationAlreadySaved = () => !isUndefined(account?.secondaryAccountHolder?.dateOfBirth);

  useEffect(() => {
    if (isPersonalInformationAlreadySaved()) {
      setIsEditable(true);
    }
  }, [account?.secondaryAccountHolder]);

  return (
    <>
      <Row className={cx(Heading.title, Spacing.my32)} data-testid={'joint-account-holder-section'}>
        {getAccountHolderSubheader({
          type: account?.type,
          authorizedSigner: 2,
        })}
      </Row>
      <MFormSection
        title='Personal Information'
        onEdit={onEdit}
        disabled={Boolean(account?.lastFailedLinkAttemptError)}
        isEditable={isEditable}
        isEditMode={isEditMode}
        tooltip={{
          icon: 'info',
          title: 'Identity Verification Instructions',
          label: 'Please enter your name as shown on a government-issued ID',
          type: 'modal',
          content: <IdentityVerificationInstructions />,
        }}
        testId={'joint-personal-information'}>
        {isPersonalInformationAlreadySaved() && !isEditMode ? (
          <PersonalInformationView accountHolder={account?.secondaryAccountHolder} isPrimary={false} />
        ) : (
          <PersonalInformationForm
            accountHolder={account?.secondaryAccountHolder}
            accountId={account?.accountId}
            accountUuid={account?.id}
            accountType={account?.type.value}
            isPrimary={false}
            onCancel={onCancel}
            testId={'joint-account-holder-section'}
          />
        )}
      </MFormSection>
    </>
  );
};
